<template>
  <div class="container-page-images">
    <div v-for="(image, index) in images" :key="index" class="container-image-export">
      <img :src="image" alt="Valuation Export Image">
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageImages',
  components: {},
  props: {
    images: {
      default: null
    }
  },
  data() {
    return {}
  },
  computed: {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.container-page-images {
  width: 100%;
  height: 100%;
  display: grid;

  grid-template-columns: 24% 24% 24% 24%;
  grid-template-rows: 49% 49%;
  gap: 20px;
  justify-content: space-between;

  .container-image-export {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: cover;
    }
  }
}
</style>
